import { logWarn } from '@web-platform/shared-universal-utils-frontend/src/helpers/logger';
import { matchPath } from 'react-router-dom';

import type { PathMatch } from 'react-router-dom';

// matchPath does not work when matching "paths" that begin with #
export const matchHashPath = (hash: string, hashPattern: string): PathMatch<string> | null => {
  if (hashPattern.startsWith('#')) {
    if (hash.startsWith('#')) {
      return matchPath(
        {
          path: hashPattern.substring(1),
          // Optional: "end" defaults to true unless specified and `true` == pattern should match the entire URL pathname
          end: false,
        },
        hash.substring(1),
      );
    }
    return null;
  }
  logWarn({
    component: 'removeHashSymbol',
    message: 'Hash pattern is not a hash',
  });
  return null;
};
